import descriptor from './descriptorOffline'

export default {
  key: 'merchant',
  title: 'Merchant',
  icon: 'shop',
  manualFilter: { key: 'account_code', value: 'account_code' },
  contentProps: {
    urlTarget: '/merchant/merchant',
    appName: 'jobs',
    modelName: 'merchant',
  },
  propsList: {
    // pageTitle: 'Test',
    avatar: 'name',
    avatarColorKey: 'branch.color',
    masterKey: 'module-merchant-account-refMerchant',
    descriptor,
  }
}